// src/utils/calendrierFiscal.ts — Échéances fiscales 2026 (stables d'une année à l'autre)

export interface EcheanceFiscale {
  id: string;
  date: Date;
  titre: string;
  description: string;
  type: 'urssaf' | 'impot' | 'cfe';
  urgence: 'critique' | 'important' | 'info';
  lien?: string;
}

export const getEcheances2026 = (isBNC = false): EcheanceFiscale[] => {
  const base: EcheanceFiscale[] = [
    // URSSAF trimestrielles
    {
      id: 'urssaf-t1',
      date: new Date('2026-04-30'),
      titre: 'Déclaration URSSAF — T1',
      description: 'Déclarez votre CA de janvier à mars sur autoentrepreneur.urssaf.fr',
      type: 'urssaf',
      urgence: 'critique',
      lien: 'https://www.autoentrepreneur.urssaf.fr',
    },
    {
      id: 'urssaf-t2',
      date: new Date('2026-07-31'),
      titre: 'Déclaration URSSAF — T2',
      description: "Déclarez votre CA d'avril à juin sur autoentrepreneur.urssaf.fr",
      type: 'urssaf',
      urgence: 'critique',
      lien: 'https://www.autoentrepreneur.urssaf.fr',
    },
    {
      id: 'urssaf-t3',
      date: new Date('2026-10-31'),
      titre: 'Déclaration URSSAF — T3',
      description: 'Déclarez votre CA de juillet à septembre sur autoentrepreneur.urssaf.fr',
      type: 'urssaf',
      urgence: 'critique',
      lien: 'https://www.autoentrepreneur.urssaf.fr',
    },
    {
      id: 'urssaf-t4',
      date: new Date('2027-01-31'),
      titre: 'Déclaration URSSAF — T4',
      description: "Déclarez votre CA d'octobre à décembre sur autoentrepreneur.urssaf.fr",
      type: 'urssaf',
      urgence: 'critique',
      lien: 'https://www.autoentrepreneur.urssaf.fr',
    },
    // Impôt sur le revenu
    {
      id: 'ir-declaration',
      date: new Date('2026-05-20'),
      titre: 'Déclaration revenus 2025',
      description: 'Déclarez vos revenus 2025 sur impots.gouv.fr — délai en ligne +15 jours vs papier',
      type: 'impot',
      urgence: 'critique',
      lien: 'https://www.impots.gouv.fr',
    },
    // CFE
    {
      id: 'cfe-paiement',
      date: new Date('2026-12-15'),
      titre: 'Paiement CFE',
      description: 'Cotisation Foncière des Entreprises — prélevée automatiquement si mandat. Entre 200€ et 1 000€ selon votre commune.',
      type: 'cfe',
      urgence: 'important',
      lien: 'https://www.impots.gouv.fr',
    },
  ];

  if (isBNC) {
    base.push({
      id: 'liasse-2035',
      date: new Date('2026-05-05'),
      titre: 'Dépôt liasse fiscale 2035',
      description: "Télétransmettez votre déclaration 2035 (revenus 2025) — délai supplémentaire de 15 jours si télédéclaration soit le 20 mai 2026",
      type: 'impot',
      urgence: 'critique',
      lien: 'https://www.impots.gouv.fr',
    });
  }

  return base.sort((a, b) => a.date.getTime() - b.date.getTime());
};

export const getStatutEcheance = (date: Date): {
  statut: 'passee' | 'urgente' | 'proche' | 'future';
  joursRestants: number;
} => {
  const aujourd = new Date();
  const diff = Math.ceil((date.getTime() - aujourd.getTime()) / (1000 * 60 * 60 * 24));
  if (diff < 0) return { statut: 'passee', joursRestants: diff };
  if (diff <= 15) return { statut: 'urgente', joursRestants: diff };
  if (diff <= 45) return { statut: 'proche', joursRestants: diff };
  return { statut: 'future', joursRestants: diff };
};
